module.exports = __webpack_public_path__ + "img/home2.16e505f0.jpg";